import React, { useState, useEffect, useCallback } from "react";
import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
  HStack,
  Badge,
  Select,
} from "@chakra-ui/react";
import axios from "axios";
import { PracticeSet, PracticeSetEvent} from '../../Platform/Common/types';
import { useNavigate } from "react-router-dom";
import { Product } from '../../Platform/Common/types';
import PracticeSetExams from "../Components/PracticeSetExams";
import PracticeSetSections from "../Components/PracticeSetSections";




interface PracticeSetProps {
  product_id: number;
  practice_set_id: number;
  onPracticeSetChange?: (event: PracticeSetEvent) => void;
}

const B2CReviewPracticeSet: React.FC<PracticeSetProps> = ({
product_id, practice_set_id,onPracticeSetChange,
}) => {


 // const B2CReviewPracticeSet = () => {
    // ────────────────────────────────────────────────────────────────────────────
    // Theme & routing hooks
    // ────────────────────────────────────────────────────────────────────────────

    const cardbg = useColorModeValue("gray.50", "gray.700");
  
  //  const { practice_set_id } = useParams<{ practice_set_id: string }>();
    const [practiceSetId, setPracticeSetId] = useState<number>(Number(practice_set_id));
    const navigate = useNavigate();
    const toast = useToast();

  
    // ────────────────────────────────────────────────────────────────────────────
    // State: core practiceSet, question-sets, mappings
    // ────────────────────────────────────────────────────────────────────────────

  
    const [practiceSet, setPracticeSet] = useState<PracticeSet>({
      practice_set_id: practiceSetId,
      product_id: product_id,
      title: '',
      description: '',
      state:"DRAFT",
      edition_label:"",
      edition_seq:0,
      created_at: new Date(),
      updated_at: new Date(),
    });


    const [products, setProducts] = useState<Product[]>([]);
   // const [availableQuestionSetGroups, setAvailableQuestionSetGroups] = useState<QuestionSetGroup[]>([]);

    const [isPsetEdited, setIsPsetEdited] = useState(false);
  
    const [isPracticeSetEdited, setIsPracticeSetEdited] = useState(false);

    const [editSessionKey, setEditSessionKey] = useState(0);
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // Mode & button logic
    // ────────────────────────────────────────────────────────────────────────────
    const [isEditing, setIsEditing] = useState(false);
    const isCreating = practiceSetId === 0;
    const isViewMode = !isEditing;

    const isDraft     = practiceSet.state === "DRAFT";
    const isPublished = practiceSet.state === "PUBLISHED";
    const isLocked   = practiceSet.state === "LOCKED";
    const isDecommissioned = practiceSet.state === "DECOMMISSIONED";
  
    const showActionButtons    = !isCreating;
    const showSaveButton       = isCreating || !isViewMode;
    const isUpdateButtonEnabled   = showActionButtons && isViewMode && (!isLocked) && (!isDecommissioned) && (!isPublished);
    const isPublishButtonEnabled   = showActionButtons && isViewMode && isDraft;
    const isDecommissionButtonEnabled   = showActionButtons && isViewMode && (isLocked || isPublished);

  
    // ────────────────────────────────────────────────────────────────────────────
    // API fetchers
    // ────────────────────────────────────────────────────────────────────────────
    const fetchPracticeSet = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeSet>(`${b2c_apiurl}/practice-set/${practiceSetId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setPracticeSet(data);
    };

    // Write fetchPracticeSetCategories, API has been written and then use Accordion logic - take help from ReviewCourseTerms


    const fetchProducts = async () => {
      try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        const response = await axios.get(`${b2c_apiurl}/products`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('b2c_token')}`,
          },
        });
        setProducts(response.data);
      } catch (error) {
        console.error("Failed to load B2C Products", error);
      }
    };

    // ────────────────────────────────────────────────────────────────────────────
    // Derived state effects
    // ────────────────────────────────────────────────────────────────────────────

    const loadAllData = useCallback(async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
      
        // 2) if editing an existing practiceSet
     //   if (Number(practice_set_id) > 0) {
     if (Number(practiceSetId) > 0) {
          await fetchPracticeSet();

         // setPracticeSetId(Number(practice_set_id));
        }
        // 3) fetch all remaining lookups
          await Promise.all([
            fetchProducts(),
          ]);
     
        // 4) reset any “edited” flags
        setIsEditing(false);
        setIsPracticeSetEdited(false);
      }, [
        practiceSetId,
        fetchPracticeSet,
        fetchProducts,
 
      ]);

    // 1) On load —  fetch everything
    useEffect(() => {
      (async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
  
  
        if (practiceSetId > 0) {
          await fetchPracticeSet();

         // setPracticeSetId(Number(practice_set_id));
        }
          await fetchProducts();

      })();
    }, [practiceSetId]);

  

  
    // ────────────────────────────────────────────────────────────────────────────
    // Form handlers
    // ────────────────────────────────────────────────────────────────────────────
    const handleInputChange = (e: React.ChangeEvent<any>) => {
      const { name, value } = e.target;
      setPracticeSet(prev => ({ ...prev, [name]: value }));
      setIsPracticeSetEdited(true);
    };

    const validatePracticeSet = () => {
          if (!practiceSet.title.trim()) return "Title is required";
          if (!practiceSet.edition_label.trim()) return "Edition label is required";
          if (!practiceSet.edition_seq) return "Edition sequence is required";
          return null;
        };

  
    // ────────────────────────────────────────────────────────────────────────────
    // Save / Create / Update / Publish / Cancel / Terminate
    // ────────────────────────────────────────────────────────────────────────────
    const handleCreatePracticeSet = async () => {
      try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        console.log("Practice Set", practiceSet);
        const { data } = await axios.post<PracticeSet>(`${b2c_apiurl}/create-practice-set/`, practiceSet, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        const newId = data.practice_set_id;
        // re-map question-sets

        toast({ title: "PracticeSet created", status: "success" });

        setIsPracticeSetEdited(false);

        await setPracticeSetId(newId);

        loadAllData();

        onPracticeSetChange?.({
        type: "CREATED",
        practiceSet: data,
      });
       // navigate(`/practice/app/b2c-practice-/review-b2c-practice-set/${newId}`);
      
      } catch (err) {
        console.error(err);
        toast({ title: "Error creating practice-set", status: "error" });
      }
    };
  
    const handleUpdatePracticeSet = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      // guard
      if ((practiceSet.state == "LOCKED") || (practiceSet.state == "DECOMMISSIONED")) {
        toast({ title: "Cannot update", status: "warning" });
        return;
      }
      try {
        await axios.put(`${b2c_apiurl}/update-practice-set/${practiceSetId}`, practiceSet, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        toast({ title: "PracticeSet updated", status: "success" });
        setIsPracticeSetEdited(false);

            onPracticeSetChange?.({
              type: "UPDATED",
              practiceSet: practiceSet,
            });
      } catch (err) {
        console.error(err);
        toast({ title: "Error updating practice set", status: "error" });
      }
    };

  const handlePublishClick = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      // guard
      if (practiceSet.state != "DRAFT") {
        toast({ title: "Cannot update", status: "warning" });
        return;
      }
      try {
        await axios.put(`${b2c_apiurl}/practice-set/${practiceSetId}/publish`, practiceSet, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        toast({ title: "PracticeSet Published", status: "success" });

        await loadAllData();

        onPracticeSetChange?.({
          type: "STATUS_CHANGED",
          id: practiceSetId,
          state: "PUBLISHED", 
        });

     } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error publishing practice set";

        toast({
          title: message,
          status: "error",
        });
      }
    };

      const handleDecommissionClick = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      // guard
          if (!(isLocked || isPublished)) {
            toast({
              title: "Only Published or Locked Practice Sets can be decommissioned",
              status: "warning",
            });
            return;
          }
      try {
        await axios.put(`${b2c_apiurl}/practice-set/${practiceSetId}/decommission`, practiceSet, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        toast({ title: "PracticeSet Decommissioned", status: "success" });
        await loadAllData();

          onPracticeSetChange?.({
          type: "STATUS_CHANGED",
          id: practiceSetId,
          state: "DECOMMISSIONED", 
        });

     } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error decommissioning practice set";

        toast({
          title: message,
          status: "error",
        });
      }
    };

  
    const handleSavePracticeSet = () => {
        const error = validatePracticeSet();
        if (error) {
          toast({ title: error, status: "error" });
          return;
        }
      isCreating ? handleCreatePracticeSet() : handleUpdatePracticeSet();
    //  setIsPracticeSetEdited(false);
    };
  
    const handleUpdateClick = async () => {
        setIsEditing(true);
          // start a brand new edit session
        setEditSessionKey(prev => prev + 1);
    }


      const handleCancelOperation = () =>{
        setIsEditing(false);  
         loadAllData();
           // invalidate ALL child component state
        setEditSessionKey(prev => prev + 1);
        };

    

  return (
    <Box as="main" mx="auto" p={2} >

 {/* PracticeSet Details Top Bar */}
    <Box bg={useColorModeValue("gray.100", "gray.700")} p={4} borderRadius="sm" mb={4}>
    <Flex direction={["column", "row"]} justify="space-between" align={["flex-start", "center"]} wrap="wrap">
        <Heading size="lg">{practiceSet.title || "Untitled PracticeSet"}</Heading>
        <HStack spacing={2} mt={[2, 0]}>
        <Badge colorScheme={
            ((practiceSet.state != "DECOMMISSIONED") && (practiceSet.state != "LOCKED"))? "purple" :"orange"
        }>
            {practiceSet.state}
        </Badge>
        </HStack>
    </Flex>

    <Flex mt={3} wrap="wrap" fontSize="sm" color={useColorModeValue("gray.600", "gray.400")}>
        <Text mr={4}><strong>Created:</strong> {new Date(practiceSet.created_at).toLocaleDateString()}</Text>
        <Text><strong>Updated:</strong> {new Date(practiceSet.updated_at).toLocaleDateString()}</Text>
    </Flex>
    </Box>

{/* Operations Buttons */}
    <Box>
    {showActionButtons && (
        <HStack spacing={2} mt={4}>
            <Button
            size="sm"
            borderRadius="sm"
            onClick={handleUpdateClick}
            isDisabled={!isUpdateButtonEnabled}
            colorScheme="blue"
            >
            Update Practice-Set
            </Button>

          <Button
            size="sm"
            borderRadius="sm"
            onClick={handlePublishClick}
            isDisabled={!isPublishButtonEnabled}
            colorScheme="purple"
            >
            Publish Practice-Set
            </Button>

          <Button
            size="sm"
            borderRadius="sm"
            onClick={handleDecommissionClick}
            isDisabled={!isDecommissionButtonEnabled}
            colorScheme="red"
            >
            Decommission Practice-Set
            </Button>

          {isEditing && (
            <Button size={"sm"} variant="outline" colorScheme="red" onClick={handleCancelOperation}>
              Cancel
            </Button>
          )}

        </HStack>
        )}
    </Box>

    {/* PracticeSet Title & Description */}
    <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md">
    <fieldset disabled={!showSaveButton}>
        <Text mb={4} fontSize="md" fontWeight="bold">Title & Description</Text>
        <VStack spacing={4} align="stretch">
        <FormControl id="title" isRequired>
            <Input
            name="title"
            placeholder="PracticeSet Title*"
            size="sm"
            value={practiceSet.title}
            onChange={handleInputChange}
            />
        </FormControl>

        <FormControl id="description" isRequired>
            <Input
            name="description"
            placeholder="PracticeSet Description*"
            size="sm"
            value={practiceSet.description}
            onChange={handleInputChange}
            />
        </FormControl>

        <FormControl id="edition_label" isRequired>
            <Input
            name="edition_label"
            placeholder="PracticeSet Edition Name*"
            size="sm"
            value={practiceSet.edition_label}
            onChange={handleInputChange}
            />
        </FormControl>

                <FormControl id="edition_seq" isRequired>
            <Input
            name="edition_seq"
            placeholder="PracticeSet Edition Sequence*"
            size="sm"
            value={practiceSet.edition_seq}
            onChange={handleInputChange}
            />
        </FormControl>



      {/* Product */}
      <FormControl id="product_id" isRequired isDisabled={!isDraft}>
      <Flex align="center" gap={4}>
          <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Product</FormLabel>
          <Select
          placeholder="Select Product"
          name="product_id"
          size="sm"
          value={practiceSet.product_id}
          onChange={handleInputChange}
          >
          {products.map((product) => (
              <option key={product.product_id} value={product.product_id}>
              {product.name}
              </option>
          ))}
          </Select>
      </Flex>
      </FormControl>


        </VStack>
    </fieldset>
            {/* Save Button */}
        {showSaveButton && (
            <Box textAlign="left" mt={4}>
                <Button
                mb={2}
                colorScheme="teal"
                size="sm"
                borderRadius="sm"
                onClick={handleSavePracticeSet}
                isDisabled={!(isPracticeSetEdited)}
                >
                Commit
                </Button>
                
            </Box>
            )}
    </Box>

    {/* PracticeSet Sections & Exams */}
    
    <Box   key={editSessionKey}  >

    <Box   
      mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md" 

        opacity={isEditing ? 1 : 0.8}
        pointerEvents={isEditing ? "auto" : "none"}
        >
          <PracticeSetSections
            practiceSetId={practiceSetId}
            isPsetEditing={isEditing}
          />
        </Box>

    <Box   
      mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md" 

        opacity={isEditing ? 1 : 0.8}
        pointerEvents={isEditing ? "auto" : "none"}
        >
          <PracticeSetExams
            practiceSetId={practiceSetId}
            isPsetEditing={isEditing}
          />
        </Box>

        </Box>
      
    </Box>
  );
};

export default B2CReviewPracticeSet;
